import axios from 'axios';
import React, { useState, useEffect, useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import moment from 'moment';
import { environment } from '../../env';
import ErrorComponents from '../errorComponents/ErrorComponents';
import AsyncSelect from 'react-select/async';
import { getBuildingAction, getSoldGalaAction, loaderAction, successModalToggle, getGalaAction } from '../../redux/actions/Index';
import PiaCharts1 from '../Chart/PiaCharts1';
import BarCharts from '../Chart/BarCharts';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Table from '../Table';
const SoldGalasModal = ({ update, galaSoldHandeler }, ...props) => {
    // List useSelector Here
    var projectList = useSelector((state) => state?.ModalReducer?.projectList);
    projectList = projectList?.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    var buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    buildingList = buildingList?.sort((a, b) => (a.building_no > b.building_no) ? 1 : ((b.building_no > a.building_no) ? -1 : 0))
    const investortype = useSelector((state) => state?.ModalReducer?.investortype);
    const soldGalaLists = useSelector((state) => state?.ModalReducer?.soldGalaList);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const dispatch = useDispatch()

    const {
        register,
        handleSubmit,
        reset,
        watch,
        control,
        setValue,
        getValues,
        formState: { errors },
    } = useForm();
    // ----------------------List useState Here---------------------
    const [modal, setModal] = useState(false);
    const [btndis, setBtndis] = useState(false);
    const [filteredGalaList, setFilteredGalaList] = useState([]);
    const [filtergalas, setFiltergalas] = useState([]);
    const [total, setTotal] = useState(0);
    const [galatable, setGalaTable] = useState();
    const [filteredSoldGalaList, setFilteredSoldGalaList] = useState([]);
    const [investorList, setInvestorList] = useState([]);
    const [projectLists, setProjectLists] = useState([]);
    const [auto, setAuto] = useState(false)
    const [errormessage, setErrormessage] = useState();
    const [filterBuilding, setFilterBuilding] = useState();
    const [previousSoldGala, setPreviousSoldGala] = useState();
    const [investorTypes, setInvestorTypes] = useState([]);
    const [piechartbuilding, setPiechartBuilding] = useState([]);
    const [noOfGalaList, setNoOfGalaList] = useState([]);
    const [keys, setkeys] = useState([]);
    const [buildingArea, setBuildingArea] = useState([]);
    const [sellError, setsellError] = useState();
    const [investorNumber, setInvestorNumber] = useState([]);
    const [areaerr, setAreaerr] = useState('');
    const [tabIndex, setTabIndex] = useState(1);
    const [load,setLoad] = useState(false);
    const [forceRender, setForceRender] = useState(true);
    // ---------------------List of toggle -----------------------
    const currentDate = moment(new Date()).format('YYYY-MM-DD');

    const toggle = () => { setModal(!modal); reset({ 'created_at': currentDate }); setLoad(true) }
    // --------------------------------------------------------
    // ---------------------List of watch -----------------------
    var selectedGalaBuiltupAreaId = watch("gala");
    var selectedSoldGalaBuiltupArea = watch("sold_gala_area");
    var selectedProject = watch('project');
    var selectedBuilding = watch('building');
    var selectedGala = watch('gala');
    var selectedtype = watch('ownertype');
    var selectednumber = watch('joined_investor')
    var count = watch('hidden')
    // --------------------------------------------------------
    //-------------------List of function Here-------------------------
    var selectedProjectDetails = projectList?.filter((projects) => projects.id == userProject);
    var totalProjectArea = `${selectedProjectDetails?.[0]?.total_area_of_project} sq`

    const getGalaData = () => {
        try {
            axios.get(`${environment.baseUrl}gala/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getGalaAction(data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getBuildingData = () => {
        try {
            axios.get(`${environment.baseUrl}building/`).then(res => {
                dispatch(getBuildingAction(res.data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const AddSoldGala = async (data) => {
        setBtndis(true);
        dispatch(loaderAction())
        let arr = []
        let daata = 0;
        const SoldGalaPayloadsingle = new FormData();
        try {
            if (data.ownertype?.label == 'Self') {
                SoldGalaPayloadsingle.append('project', userProject)
                SoldGalaPayloadsingle.append('building', data.building?.value)
                SoldGalaPayloadsingle.append('Investors', data.Investors?.value)
                SoldGalaPayloadsingle.append('gala', data.gala)
                SoldGalaPayloadsingle.append('ownertype', 'Self')
                SoldGalaPayloadsingle.append('ownership', 1)
                SoldGalaPayloadsingle.append('sold_gala_area', data.sold_gala_area)
                SoldGalaPayloadsingle.append('sub_gala_name', data.sub_gala_name)
                SoldGalaPayloadsingle.append('created_at', data?.created_at)
                SoldGalaPayloadsingle.append('index', data?.index)
            }
            else {
                for (let i = 1; i < Number(selectednumber) + 1; i++) {
                    const SoldGalaPayload = new FormData();
                    SoldGalaPayload.append('project', userProject)
                    SoldGalaPayload.append('building', data.building?.value)
                    SoldGalaPayload.append('created_at', data?.created_at)
                    SoldGalaPayload.append('index', data?.index)
                    SoldGalaPayload.append('Investors', eval("data.Investors_" + i + "?.value"))
                    SoldGalaPayload.append('gala', data.gala)
                    SoldGalaPayload.append('ownertype', 'Joined')
                    SoldGalaPayload.append('ownership', 1)
                    SoldGalaPayload.append('sold_gala_area', eval("data.sold_gala_area_" + i))
                    SoldGalaPayload.append('sub_gala_name', eval("data.sub_gala_name_" + i))
                    daata = Array.from(SoldGalaPayload.entries()).reduce((memo, [key, value]) => ({
                        ...memo,
                        [key]: value,
                    }), {});
                    arr.push(daata);
                }
            }
            await axios.post(`${environment.baseUrl}sold-gala/`, data.ownertype?.label == 'Self' ? SoldGalaPayloadsingle : arr).then((soldgala) => {
                if (soldgala.data.code === 200) {
                    getGalaData();
                    dispatch(successModalToggle());
                    dispatch(loaderAction())
                    toggle();
                    setLoad(false)
                    getBuildingData();
                    reset();
                    setBtndis(false);
                    setErrormessage();
                    galaSoldHandeler();
                    setTabIndex(1)
                }
            })
            setBtndis(false);
        }
        catch (err) {
            setBtndis(false);
            console.log(err);
        }
    };

    useEffect(()=>{
        if (selectedtype?.label == 'Join'){
            setValue('hidden', 0)
            setTimeout(()=>{
                setValue('hidden', 1)
                // setValue(`sold_gala_area_${0}`,"")
                // setValue(`sub_gala_name_${0}`,"")
                // setValue(`Investors_${0}`, "Investor"); //
                GalaArea({ 'label': 'asdasd', 'value': selectedGala }, 1, false)
            },200)
        }else{
            setForceRender(false)
            setTimeout(()=>{
                setForceRender(true)
                setValue('Investors', "")
            },200)
        }
    },[selectedBuilding,selectedGala])

    const getSoldGalaData = () => {
        try {
            axios.get(`${environment.baseUrl}sold-gala/`).then(res => {
                dispatch(getSoldGalaAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const column = [
        {
            name: 'Gala No',
            selector: row => Number(row.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Builtup Area',
            selector: row => (row.builtup_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Sold Area',
            selector: row => (row.builtup_area - row.available_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Reamining Area',
            selector: row => (row.available_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ];
    const columns = [
        {
            name: 'Gala No',
            selector: row => Number(row.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Builtup Area',
            selector: row => (row.builtup_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Sold Area',
            selector: row => (row.builtup_area - row.available_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Reamining Area',
            selector: row => (row.available_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ]
    const CancelButton = () => {
        setkeys();
        toggle();
        setLoad(false)
        setBtndis(false);
        reset();
        setNoOfGalaList([]);
        setPreviousSoldGala();
        setErrormessage();
        setTabIndex(1);
        setInvestorNumber();
        setsellError("");
        setAreaerr('')
    }

    const GalaArea = (e, number, edit) => {
        if (edit == false) {
            if (number < 0) {
                const area = filtergalas.filter((gala) => gala.id == e.value);
                setValue(`available_area`, area[0].available_area);
                setValue(`gala`, area[0].id);
            } else {
                const area = filtergalas.filter((gala) => gala.id == e.value)
                setValue(`available_area_${number}`, area[0]?.available_area);
                // setValue(`gala_${number}`, area[0]?.id);
            }
        } else {
            setValue(`available_area_${number + 1}`, getValues(`available_area_${number}`) - e)
        }
    }

    useMemo(() => {
        if (selectedtype?.label == 'Join') {
            let i = 1;
            let arr = []
            if (selectednumber == undefined) {
                setValue('hidden', 1)
            }
            if (count <= selectednumber) {
                while (i < Number(count) + 1) {
                    arr.push(i)
                    i++;
                }
                setInvestorNumber(arr);
            }
            GalaArea({ 'label': 'asdasd', 'value': selectedGala }, 1, false)
        }
    }, [selectednumber, selectedtype, count])
    useMemo(() => {
        if (selectedtype) {
            setTabIndex(0)
        }
    }, [selectedtype])
    useMemo(() => {
        if (!sellError) {
            setsellError("");
        }
    }, [sellError])
    const GetInverster = async (gala) => {
        dispatch(loaderAction())
        if(userProject != undefined){
            const GetInvesterURL = `${environment.baseUrl}sold-gala-investor-filter/?gala=${gala == undefined ? "" :gala}&project=${userProject == undefined? "" : userProject}&building=${selectedBuilding?.label == undefined ? "" : selectedBuilding.label}`;
            try {
                var newInvestorList = [];
                await axios.get(GetInvesterURL).then((investorResponse) => {
                    dispatch(loaderAction())
                    investorResponse.data.map((investorsList) => {
                        newInvestorList.push({ label: `${investorsList.name} B:${investorsList.building.building_no} G:${investorsList.gala.gala_no}`, value: investorsList.id })
                    })
                })
                setInvestorList(newInvestorList);
            }
            catch (err) {
                dispatch(loaderAction())
            }
        }
    }
    const GalaTable = (gala, building, project) => {
        if(load){
            dispatch(loaderAction())
            if (gala == undefined) {
                gala = ''
            }
            if (building == undefined) {
                building = ''
            }
            if (project == undefined) {
                project = ''
            }
            const GetGalas = `${environment.baseUrl}gala-filter/?gala_no=${gala}&building=${building}&project=${project}`;
            try {
                axios.get(GetGalas).then((res) => {
                    let filterData = [];
                    res.data?.map(data => {
                        if(data.project.id == userProject){
                            filterData.push(data)
                        }
                    });
                    setGalaTable(filterData);
                })
            }
            catch (err) {
                dispatch(loaderAction())
            }
        }
    }
    const filterGala = async (project, building) => {
        var allGalaDetails;
        var galaList = []
        var soldGalaDetailshere;
        var BuildingArea = []
        if (project == undefined || building == undefined) {
            return
        }
        // --- building and project gala details code starts here ---
        const FilterGalaPayload = new FormData();
        FilterGalaPayload.append('project', project);
        FilterGalaPayload.append('building', building);
        const FilterGalaURL = `${environment.baseUrl}filter-gala/`;
        await axios.post(FilterGalaURL, FilterGalaPayload).then((response) => {
            allGalaDetails = response.data.data;
            setFiltergalas(response.data.data)
            response.data.data.map((newgalalist) => {
                galaList.push({ label: newgalalist.gala_no, value: newgalalist.id })
                BuildingArea.push({ id: `${newgalalist.gala_no} Occupied`, "label": `${newgalalist.gala_no} Occupied`, "value": newgalalist.builtup_area })
            })
            const selectedBuildingDetails = buildingList?.filter((building) => building.id == selectedBuilding.value);
            const bldgBuiltUpAreaCalc = response.data.data.reduce((a, b) => a + b.builtup_area, 0);
            const remaining_area = selectedBuildingDetails[0].area_builtup - bldgBuiltUpAreaCalc;
            BuildingArea.push({ id: `Available`, label: `Available`, value: remaining_area })
        });
        // --- building and project gala details code ends here ---
        // --- sold gala details code starts here ---
        const soldGalaDetail = `${environment.baseUrl}filter-sold-gala-forgraph/`;
        await axios.post(soldGalaDetail, FilterGalaPayload).then((response) => {
            soldGalaDetailshere = response.data.data;
        });
        // -- sold gala details code ends here ---
        var soldgalabar = [];
        allGalaDetails.map((data, index) => {
            let bigCities = soldGalaDetailshere.filter(city => city.gala == data.id);
            if (bigCities.length > 0) {
                const totalScores = bigCities.reduce((previousScore, currentScore, index) => previousScore + (currentScore.sold_gala_area - currentScore.resell_area), 0);
                soldgalabar.push({
                    "id": `Gala ${data.gala_no}`,
                    "gala": data.gala_no,
                    "Available": data.builtup_area - totalScores,
                    "Occupied": totalScores,
                    "Builtup Area": data.builtup_area
                })
            } else {
                const totalScores = bigCities.reduce((previousScore, currentScore, index) => previousScore + (currentScore.sold_gala_area - currentScore.resell_area), 0);
                soldgalabar.push({
                    "id": `Gala ${data.gala_no}`,
                    "gala": data.gala_no,
                    "Available": data.builtup_area - totalScores,
                    "Occupied": totalScores,
                    "Builtup Area": data.builtup_area
                })
            }
        });
        setkeys(['Available', 'Occupied', 'Builtup Area']);
        setNoOfGalaList(soldgalabar);
        galaList.sort((a,b)=>(a?.label || 0) - (b?.label || 0))
        setFilteredGalaList(galaList);
        setBuildingArea(BuildingArea)
    };
    const buildingpiechart = async (project, building) => {
        const buildingPayload = new FormData();
        buildingPayload.append('project', project);
        const buildingPieChartURL = `${environment.baseUrl}building-list/`;
        dispatch(loaderAction())
        try {
            var buildingchart = []
            await axios.post(buildingPieChartURL, buildingPayload).then((buildingresponse) => {
                buildingresponse.data.data.map((buildingpiechart) => {
                    dispatch(loaderAction())
                    buildingchart.push({ id: `${buildingpiechart.building_no} Occupied`, label: `${buildingpiechart.building_no} Occupied`, value: buildingpiechart.area_builtup })
                })
                const selectedProjectDetails = projectList?.filter((projects) => projects.id == userProject);
                const bldgBuiltUpAreaCalc = buildingresponse.data.data.reduce((a, b) => a + b.area_builtup, 0);
                const remaining_area = selectedProjectDetails[0].total_area_of_project - bldgBuiltUpAreaCalc;
                buildingchart.push({ id: `Available`, label: `Available`, value: remaining_area })
            })
            setPiechartBuilding(buildingchart);
        }
        catch (err) {
            dispatch(loaderAction())
        }
    };
    const filterSoldGala = async (project, building, gala) => {
        if (project == undefined || building == undefined || gala == undefined) {
            return
        }
        const FilterSoldGalaPayload = new FormData();
        FilterSoldGalaPayload.append('project', project);
        FilterSoldGalaPayload.append('building', building);
        FilterSoldGalaPayload.append('gala', gala);
        const FilterSoldGalaURL = `${environment.baseUrl}filter-sold-gala/`;
        dispatch(loaderAction())
        try {
            var soldGalaList = []
            await axios.post(FilterSoldGalaURL, FilterSoldGalaPayload).then((soldgalaresponse) => {
                setPreviousSoldGala(soldgalaresponse.data.data)
                dispatch(loaderAction())
                soldGalaList.push(soldgalaresponse.data.data)
                soldgalaresponse.data.data.map((newgalalist) => {
                    soldGalaList.push({ label: newgalalist?.gala_no, value: newgalalist?.id })
                })
            })
            setFilteredSoldGalaList(soldGalaList);
        }
        catch (err) {
            dispatch(loaderAction());
        }
    };

    const customSort = (a, b) => {
        const aIsNumber = !isNaN(Number(a.gala.gala_no));
        const bIsNumber = !isNaN(Number(b.gala.gala_no));
      
        if (aIsNumber && bIsNumber) {
          return Number(a.gala.gala_no) - Number(b.gala.gala_no);
        } else if (aIsNumber) {
          return -1;
        } else if (bIsNumber) {
          return 1;
        } else {
          return a.gala.gala_no.localeCompare(b.gala.gala_no);
        }
      }

    const InvestorOptions = async (query) => {
        let dd;
        const filteredInvestorURL = `${environment.baseUrl}filter-investor/`;
        const FilterInvestorPayload = new FormData();
        FilterInvestorPayload.append('query', query);
        FilterInvestorPayload.append('building', selectedBuilding.value);
        FilterInvestorPayload.append('gala', "");
        const result = await axios.post(filteredInvestorURL, FilterInvestorPayload).then((response) => {
            let filteredInvesters = [];
            let curentProjectInvestor = [];
            if(response?.data?.length > 0){
                response.data.sort(customSort);
            }
            response.data.map(item => {
                if (item.building.project == userProject){
                    curentProjectInvestor.push(item);
                }
            })
            curentProjectInvestor.map((invesrtorList) => {
                filteredInvesters.push({ label: `${invesrtorList.name} B:${invesrtorList.building.building_no} G:${invesrtorList.gala.gala_no}`, value: invesrtorList.id })
            })
            dd = filteredInvesters;
        })
        if (dd.length > 0) {
            return dd
        } else {
            return []
        }
    };
    const ProjectOptions = async (query) => {
        let filteredProjects;
        const filteredProjectURL = `${environment.baseUrl}filter-project/`;
        const FilterProjectPayload = new FormData();
        FilterProjectPayload.append('query', query);
        const result = await axios.post(filteredProjectURL, FilterProjectPayload).then((response) => {
            let filteredProject = [];
            response.data.sort((a, b) => (a.projectList.name > b.projectList.name) ? 1 : ((b.projectList.name > a.projectList.name) ? -1 : 0))
            response.data.map((projectList) => {
                filteredProject.push({ label: projectList.name, value: projectList.id })
            })
            filteredProjects = filteredProject;
        })
        if (filteredProjects.length > 0) {
            return filteredProjects
        } else {
            return []
        }
    };
    const BuildingOptions = async (query) => {
        let filteredBuildings;
        const filteredBuildingURL = `${environment.baseUrl}filter-building/`;
        const FilterBuildingPayload = new FormData();
        FilterBuildingPayload.append('query', query);
        const result = await axios.post(filteredBuildingURL, FilterBuildingPayload).then((response) => {
            let filteredBuilding = [];
            response.data.map((BuildingList) => {
                filteredBuilding.push({ label: BuildingList.building_no, value: BuildingList.id })
            })
            filteredBuildings = filteredBuilding;
        })

        if (filteredBuildings.length > 0) {
            return filteredBuildings
        } else {
            return []
        }
    };

    const GalaOptions = async (query) => {
        let filteredGalas;
        const filteredGalaURL = `${environment.baseUrl}filter-gala-List/`;
        const FilterGalaPayload = new FormData();
        FilterGalaPayload.append('query', query);
        FilterGalaPayload.append('building', selectedBuilding?.value);
        FilterGalaPayload.append('project', userProject);
        const result = await axios.post(filteredGalaURL, FilterGalaPayload).then((response) => {
            let filteredGala = [];
            response.data.map((GalaList) => {
                filteredGala.push({ label: GalaList.gala_no, value: GalaList.id })
            })
            filteredGalas = filteredGala;
        })
        if (filteredGalas.length > 0) {
            return filteredGalas
        } else {
            return []
        }
    };
    useEffect(() => {
        // GetInverster();
        filterGala();
        filterSoldGala();
    }, []);
    useMemo(() => {
        let buildinglist = [];
        if (userProject) {
            var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
            projectBuilding?.map((building) => {
                buildinglist.push({ label: building.building_no, value: Number(building.id) })
            })
            setFilterBuilding(buildinglist)
            GalaTable("", "", selectedProject?.label)
            buildingpiechart(userProject);
        }
    }, [userProject])

    useEffect(()=>{
        if(userProject && buildingList != undefined){
            let buildinglist = [];
            var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
            projectBuilding?.map((building) => {
                buildinglist.push({ label: building.building_no, value: Number(building.id) })
            })
            setFilterBuilding(buildinglist)
        }
    },[userProject, buildingList])

    useMemo(() => {
        if (selectedGalaBuiltupAreaId?.value) {
            const selectedGalaBuiltupDetails = filtergalas?.filter((galalist) => galalist.id == selectedGalaBuiltupAreaId?.value);
            let selectedSoldGala = 0
            filteredSoldGalaList[0]?.map((item) => {
                selectedSoldGala += parseInt(item?.sold_gala_area);
            });
            const totalgalabuiltuparea = selectedGalaBuiltupDetails[0]?.builtup_area - selectedSoldGala
            if (selectedSoldGalaBuiltupArea > (totalgalabuiltuparea)) {
                setErrormessage(`${selectedSoldGalaBuiltupArea} is greater then ${totalgalabuiltuparea} `)
            }
            else {
                setErrormessage("")
            }
        }
    }, [selectedGalaBuiltupAreaId, selectedSoldGalaBuiltupArea, errormessage]);
    useMemo(() => {
        if (userProject && selectedBuilding?.value) {
            filterGala(userProject, selectedBuilding?.value);
            GalaTable("", selectedBuilding?.label, selectedProject?.label)
        }
    }, [userProject, selectedBuilding?.value, selectedBuilding]);
    useMemo(() => {
        if (userProject && selectedBuilding?.value && selectedGala?.value) {
            filterSoldGala(userProject, selectedBuilding?.value, selectedGala?.value);
            GalaTable(selectedGala?.label, selectedBuilding?.label, selectedProject?.label)
        }
    }, [userProject, selectedBuilding?.value, selectedGala?.value]);
    useMemo(() => {
        let cc = [];
        if (projectList) {
            projectList.map((project) => {
                cc.push({ label: project.name, value: project.id })
            })
        }
        setProjectLists(cc)
    }, [projectList]);
    useMemo(() => {
        let investorTypeList = [];
        if (investortype) {
            investortype.map((investor) => {
                investorTypeList.push({ label: investor.investor_type, value: investor.id })
            })
        }
        setInvestorTypes(investorTypeList.reverse())
    }, [investortype]);
    const handleNumChange = event => {
        const limit = 20;
        if (event.target.value <= limit) {
            setValue('joined_investor', event.target.value);
        }
    };
    const CheckArea = (e, number) => {
        e = Number(e).toFixed(2)
        if (number != undefined) {
            const area = getValues(`available_area_${number}`)
            if (Number(e) > Number(area)) {
                setAreaerr(`Sell Gala Area ${e} Is Greater than Available Area ${area}`)
            } else {
                setAreaerr('')
            }
        }
        else {
            const area = getValues(`available_area`)
            if (Number(e) > Number(area)) {
                setAreaerr(`Sell Gala Area ${e} Is Greater than Available Area ${area}`)
            } else {
                setAreaerr('')
            }
        }
    }
    return (
        <>
            <Button onClick={toggle} className='border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5 buttons py-4 btn btn-secondary'><span className='fs-3 d-flex gap-3 title-font-600 ps-3 pe-2'>Sale Gala</span></Button>
            <Modal className='border-0 transitions-easy' isOpen={modal} toggle={props.toggle} size={userProject == undefined ? `lg` : 'xl'}
                centered >
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>Sale Gala</span></ModalHeader>
                <Form onSubmit={handleSubmit(AddSoldGala)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className={`${userProject == undefined ? "row align-items-center" : `${userProject !== undefined ? "row flex-column flex-md-row flex-lg-row flex-xl-row" : "row flex-column flex-md-row flex-lg-row flex-xl-row"}`}`}>
                            <div className={`${userProject == undefined ? "col-12" : "col-12 col-md-12 col-lg-4 col-xl-4 "}`}>
                                <div className="row">
                                    {/* <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                            Project Name *
                                        </Label>
                                        <br />
                                        <div className='mt-1  d-flex gap-3'>
                                            <Controller
                                                control={control}
                                                name="project"
                                                rules={{ required: true }}
                                                render={({
                                                    field: { onChange },
                                                    fieldState: { isTouched, isDirty, error },
                                                    formState,
                                                }) => (
                                                    <AsyncSelect placeholder="Search Project" cacheOptions defaultOptions={projectLists} loadOptions={ProjectOptions} onChange={onChange} className='w-100' name='project' />
                                                )}
                                            />
                                        </div>
                                        {errors.project && <ErrorComponents error={'Project Name is required *'} />}
                                        <br />
                                    </div> */}
                                    <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                            Building No *
                                        </Label>
                                        <br />
                                        <div className='mt-1  d-flex gap-3'>
                                            <Controller
                                                control={control}
                                                name="building"
                                                rules={{ required: true }}
                                                render={({
                                                    field: { onChange },
                                                    fieldState: { isTouched, isDirty, error },
                                                    formState,
                                                }) => (
                                                    <AsyncSelect placeholder="Search Building" cacheOptions defaultOptions={filterBuilding} loadOptions={BuildingOptions} className='w-100' onChange={onChange} />
                                                )}
                                            />
                                        </div>
                                        {errors.building && <ErrorComponents error={'building No is required *'} />}
                                        <br />
                                    </div>
                                    <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                            Gala No *
                                        </Label>
                                        <br />
                                        <div className='mt-1  d-flex gap-3'>
                                            <Controller
                                                control={control}
                                                name="gala"
                                                rules={{ required: true }}
                                                render={({
                                                    field: { onChange },
                                                    fieldState: { isTouched, isDirty, error },
                                                    formState,
                                                }) => (
                                                    <AsyncSelect cacheOptions defaultOptions={filteredGalaList} loadOptions={GalaOptions}
                                                        onChange={
                                                            (e) => { onChange(e.value); GalaArea(e, -2, false); GetInverster(e.value) }
                                                        }
                                                        className='w-100' />
                                                )}
                                            />
                                        </div>
                                        {errors.gala && <ErrorComponents error={'Gala No is required *'} />}
                                        <br />
                                    </div>
                                    <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                            Ownership Type *
                                        </Label>
                                        <br />
                                        <div className='mt-1  d-flex gap-3'>
                                            <Controller
                                                control={control}
                                                name="ownertype"
                                                rules={{ required: true }}
                                                render={({
                                                    field: { onChange },
                                                    fieldState: { isTouched, isDirty, error },
                                                    formState,
                                                }) => (
                                                    <AsyncSelect placeholder="Investor type" cacheOptions defaultOptions={investorTypes} onChange={onChange} className='w-100' />
                                                )}
                                            />
                                        </div>
                                        {errors.ownertype && <ErrorComponents error={'Ownership Type is required *'} />}
                                        <br />
                                    </div>
                                    <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                            Selling date
                                        </Label>
                                        <br />

                                        <div className='mt-1  d-flex gap-3'>
                                            <input
                                                className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                type='date'
                                                {...register("created_at",
                                                    {
                                                        required: true
                                                        ,
                                                    })}
                                            />
                                        </div>
                                        {errors.created_at && <ErrorComponents error={'Selling date is required *'} />}
                                        <br />
                                    </div>
                                    <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                        <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                            Index No
                                        </Label>
                                        <br />

                                        <div className='mt-1  d-flex gap-3'>
                                            <input
                                                className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                                type='text'
                                                placeholder='Index Number'
                                                {...register("index") }
                                            />
                                        </div>
                                        {errors.index && <ErrorComponents error={'index number is required *'} />}
                                        <br />
                                    </div>
                                    {selectedtype?.label == 'Join' ?
                                        <>
                                            <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                                    Joined Investors Number
                                                </Label>
                                                <br />
                                                <div className='mt-1  d-flex gap-4'>
                                                    <input
                                                        className="p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input"
                                                        type="number"
                                                        min={0}
                                                        name="num"
                                                        disabled={(e) => { e.target.value == 1 }}
                                                        onChange={() => handleNumChange(e)}
                                                        placeholder="Enter Number of Investors"
                                                        {...register("joined_investor", {
                                                            required: true,
                                                        })}
                                                    />
                                                </div>
                                                {
                                                    selectednumber >= 10 &&
                                                    <h4 className="fs-4 text-base-black text-danger pt-3 ">Joined Investors Number is less than 10</h4>
                                                }
                                                {errors.joined_investor && <ErrorComponents error={'Investors Number is required *'} />}
                                                <br />
                                            </div>
                                        </> : <>
                                            {previousSoldGala?.map((soldGala, i) => {
                                                return (
                                                    <h5 className='text-black py-3 border border-black mt-3  px-1 bg-white border-radius-10  align-items-center d-flex' key={i}>
                                                        <i className='bx bx-info-circle bx-tada fs-1 pe-2' ></i>
                                                        <div className="fs-4">
                                                            <span className='base-font-800 fs-4  '>Previous Investor : </span>{soldGala.Investors?.name}, Occupied Area : {soldGala.sold_gala_area} sqft
                                                        </div>
                                                    </h5>
                                                )
                                            })}
                                        </>
                                    }
                                </div>
                            </div>
                            {
                                total != 0 &&
                                <>
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type="text"
                                        placeholder="hidden"
                                        {...register("hidden")}
                                    />
                                </>
                            }
                            <div className={`${userProject == undefined ? "d-none" : "col-12 col-md-12 col-lg-8 col-xl-8"}`}>
                                <div className="row">
                                    <Tabs selectedIndex={tabIndex} onSelect={(index) =>
                                        setTabIndex(index)} className="">
                                        <div className="d-flex justify-content-center mb-4">
                                            <TabList className="d-flex sellGalaTabsMain gap-2  py-2 rounded">
                                                <Tab className="sellGalaTabs fs-3 py-3 px-5 title-font-700">Inputs</Tab>
                                                <Tab className="sellGalaTabs fs-3 py-3 px-5 title-font-700">Table</Tab>
                                                <Tab className="sellGalaTabs fs-3 py-3 px-5 title-font-700">Charts</Tab>
                                            </TabList>
                                        </div>
                                        <TabPanel>
                                            {
                                                forceRender && selectedtype?.label == 'Self' ?
                                                    selectedtype?.label == 'Self' ?
                                                        <div className="bg-white py-2 px-3 rounded-5">
                                                            <div>
                                                                <div className={`${userProject !== undefined ? "col-12 pb-3 pt-2" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                                                    <editable-table>
                                                                        <table className=''>
                                                                            <thead className=''>
                                                                                <tr >
                                                                                    <th className='fs-5 col-3 title-font-600 mb-0 text-base-color'>
                                                                                        Select Investor
                                                                                    </th>
                                                                                    <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                                                                        Available Area
                                                                                    </th>
                                                                                    <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                                                                        Sold Area
                                                                                    </th>
                                                                                    <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                                                                        Sub-Gala Name
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr >
                                                                                    <th style={{ display: "contents" }}>
                                                                                        <td className="pb-2 ps-2">
                                                                                            <Controller
                                                                                                className="p-3 mb-3 border-radius-10 shadow-none  w-100 fs-4 base-font-500 modal-input"
                                                                                                control={control}
                                                                                                name="Investors"
                                                                                                rules={{ required: true }}
                                                                                                render={({
                                                                                                    field: { onChange },
                                                                                                    fieldState: { isTouched, isDirty, error },
                                                                                                    formState,
                                                                                                }) => (
                                                                                                    <AsyncSelect placeholder="Investor" cacheOptions defaultOptions={investorList} loadOptions={InvestorOptions} onChange={onChange} className='w-100' />
                                                                                                )}
                                                                                            />
                                                                                        </td>
                                                                                        <td className=' pb-2 ps-2 '>
                                                                                            <input
                                                                                                className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                                                                min="0"
                                                                                                type="number"
                                                                                                placeholder="Area...."
                                                                                                disabled
                                                                                                {...register(`available_area`)}
                                                                                            />
                                                                                        </td>
                                                                                        <td className=' pb-2 ps-2 '>
                                                                                            <input
                                                                                                className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                                                                min="0"
                                                                                                step="any"
                                                                                                type="number"
                                                                                                placeholder="Area...."
                                                                                                {...register(`sold_gala_area`, {
                                                                                                    required: true,
                                                                                                    onChange: (e) => {
                                                                                                        CheckArea(e.target.value)
                                                                                                    }
                                                                                                })}
                                                                                            />
                                                                                        </td>
                                                                                        <td className="pb-2 ps-2">
                                                                                            <div className='mt-1  d-flex gap-3'>
                                                                                                <input
                                                                                                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                                                                    type="text"
                                                                                                    placeholder="SubGala"
                                                                                                    {...register("sub_gala_name", {
                                                                                                        required: true,
                                                                                                        onChange: (e) => { e.target.value = e.target.value.toUpperCase() }
                                                                                                    })}
                                                                                                />
                                                                                            </div>
                                                                                            <br />
                                                                                        </td>
                                                                                    </th>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </editable-table>
                                                                    {areaerr &&
                                                                        <ErrorComponents error={areaerr} />
                                                                    } 

                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="bg-white py-2 px-3 rounded-5">
                                                            <h3 className="text-base-color fs-3 base-font-600">Please Select Ownership Type </h3>
                                                        </div>
                                                    :
                                                    investorNumber != 0 && selectednumber <= 10 && investorNumber != undefined ?
                                                        <div className="bg-white py-2 px-3 rounded-5">
                                                            <div>
                                                                <div className={`${userProject !== undefined ? "col-12 pb-3 pt-2" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                                                    <editable-table>
                                                                        <table className=''>
                                                                            <thead className=''>
                                                                                {(investorNumber != 0 && investorNumber != undefined) &&
                                                                                    <tr >
                                                                                        <th className='fs-5 col-3 title-font-600 mb-0 text-base-color'>
                                                                                            Select Investor
                                                                                        </th>
                                                                                        <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                                                                            Available Area
                                                                                        </th>
                                                                                        <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                                                                            Sold Area
                                                                                        </th>
                                                                                        <th className='fs-5 col-2 title-font-600 mb-0 text-base-color'>
                                                                                            Sub-Gala Name
                                                                                        </th>
                                                                                    </tr>}
                                                                            </thead>
                                                                            <tbody>
                                                                                {(investorNumber != 0 && investorNumber != undefined) &&
                                                                                    <>
                                                                                        {investorNumber.map((number, i) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <tr key={i}>
                                                                                                        <th scope="" style={{ display: "contents" }}>
                                                                                                            <td className=' pb-2 '>
                                                                                                                <Controller
                                                                                                                    className="p-3 mb-3  border-radius-10 shadow-none  fs-4 title-font-500 fs-2 modal-input"
                                                                                                                    control={control}
                                                                                                                    name={`Investors_${number}`}
                                                                                                                    rules={{ required: true }}
                                                                                                                    render={({
                                                                                                                        field: { onChange },
                                                                                                                        fieldState: { isTouched, isDirty, error },
                                                                                                                        formState,
                                                                                                                    }) => (
                                                                                                                        <AsyncSelect placeholder="Investor" cacheOptions defaultOptions={investorList} loadOptions={InvestorOptions} onChange={onChange} className='w-100' />
                                                                                                                    )}
                                                                                                                />
                                                                                                            </td>
                                                                                                            <td className=' pb-2 ps-1'>
                                                                                                                <input
                                                                                                                    className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                                                                                    min="0"
                                                                                                                    type="number"
                                                                                                                    placeholder="Area...."
                                                                                                                    disabled
                                                                                                                    {...register(`available_area_${number}`)}
                                                                                                                />
                                                                                                            </td>
                                                                                                            <td className=' pb-2 ps-1'>
                                                                                                                <input
                                                                                                                    className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                                                                                                    min="0"
                                                                                                                    type="number"
                                                                                                                    step="any"
                                                                                                                    placeholder="Area...."
                                                                                                                    {...register(`sold_gala_area_${number}`, {
                                                                                                                        required: true,
                                                                                                                        onChange: (e) => {
                                                                                                                            CheckArea(e.target.value, number)
                                                                                                                        }, onBlur: (e) => {
                                                                                                                            GalaArea(e.target.value, number, true); CheckArea(e.target.value, number);
                                                                                                                        }
                                                                                                                    })}
                                                                                                                />
                                                                                                            </td>
                                                                                                            <td className=' pb-2 ps-1'>
                                                                                                                <input
                                                                                                                    className="p-3 mb-0 border-radius-10 shadow-none  w-100 fs-4 title-font-500 text-uppercase fs-2 modal-input"
                                                                                                                    type="text"
                                                                                                                    placeholder="Sub Gala."
                                                                                                                    {...register(`sub_gala_name_${number}`, {
                                                                                                                        required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() }, onBlur: () => { setValue('hidden', Number(count) + 1) }
                                                                                                                    })}
                                                                                                                />
                                                                                                            </td>
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </>
                                                                                            )
                                                                                        })}
                                                                                    </>
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </editable-table>
                                                                    {areaerr && <ErrorComponents error={areaerr} />}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="bg-white py-3 px-5 rounded-5 text-center">
                                                            <h3 className="text-base-color fs-3 base-font-600">Please Select Ownership Type </h3>
                                                        </div>
                                            }
                                            {sellError && <ErrorComponents error={sellError} />}

                                        </TabPanel>
                                        <TabPanel>
                                            <div className="bg-white py-4 px-4  rounded-5">
                                                <div>
                                                    <h2 className='mb-3 title-font-600 '>Gala's</h2>
                                                    {selectedBuilding && <Table columns={selectedBuilding ? columns : column} data={galatable} />}
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel>
                                            <div className={`${userProject == undefined ? "d-none" : "col-12 d-flex gap-1 "}`}>
                                                <div className={`${userProject == undefined ? "d-none" : `${selectedBuilding !== undefined ? "col-6" : "col-12"}`}`}>
                                                    <div className='col-12'>
                                                        <h4 className='pt-2 mb-0 pb-4 ps-2 text-capitalize text-center'>{selectedProject?.label} {totalProjectArea == 'undefined sqrt' ? '' : totalProjectArea} </h4>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <div className={`${userProject == undefined ? "w-h-350" : `${selectedBuilding == undefined ? "w-h-400" : "w-h-350"}`}`} >
                                                                <PiaCharts1 piechartdata={piechartbuilding} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`${selectedBuilding == undefined ? "d-none" : "col-6 border-left-color-2"}`}>
                                                    <div className='col-12 '>
                                                        {selectedBuilding?.label && <h4 className='pt-2 mb-0 pb-4 text-capitalize text-center '>Building No: {selectedBuilding?.label}</h4>}
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <div className='w-h-350'>
                                                                <PiaCharts1 selectedBuilding={selectedBuilding} piechartdata={buildingArea} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                            {
                                tabIndex == 2 &&
                                <div className={selectedBuilding == undefined ? "d-none" : "col-12"}>
                                    <div className='col-12 '>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="" style={{ height: "400px", width: "100%" }}>
                                                <BarCharts noOfGalaList={noOfGalaList} keys={keys} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>{' '}
                        <Button type='submit' className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={errormessage || areaerr !== '' || btndis} ><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Submit</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};
export default SoldGalasModal